import * as React from 'react';

function Bobsleigh(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.992 7.498a.482.482 0 01-.117.234l-.811.88.055.02.054.024.4.2a.674.674 0 01.23 1.014l-.055.063-1.501 1.501a.788.788 0 01-.71.215l-.096-.025-.79-.264a.693.693 0 01-.085-.034l-3.461 3.758.759.38c.05.025.098.056.141.091l.063.057a.787.787 0 01.062 1.044l-.062.069-2.223 2.223a.787.787 0 01-.71.215l-.095-.025-1.276-.426-.49.533a.787.787 0 01-.15.126 3.935 3.935 0 11-5.494-5.496.795.795 0 01.126-.148l.532-.49-.425-1.275a.787.787 0 01.19-.806l2.224-2.224a.787.787 0 011.26.205l.38.759 3.758-3.46a.686.686 0 01-.035-.085l-.264-.79a.788.788 0 01.191-.806l1.501-1.5a.673.673 0 011.078.174l.2.4a.789.789 0 01.044.109l.88-.81a.482.482 0 01.8.262l.12.61c.03.154.105.295.215.406l2.191 2.19c.11.11.252.186.405.216l.611.12a.482.482 0 01.38.567v-.001zM9.72 14.283a1.574 1.574 0 10-2.226 2.225 1.574 1.574 0 002.226-2.225zm2.783-2.783a1.575 1.575 0 10-2.265 2.187 1.575 1.575 0 002.265-2.187zm2.784-2.784a1.575 1.575 0 10-2.227 2.229 1.575 1.575 0 002.227-2.229zm2.783-2.782a1.575 1.575 0 10-2.227 2.227 1.575 1.575 0 002.227-2.227z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Bobsleigh;
